<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap dq-page-actions"
        >
          <div class="mb-2">
            <div class="dropdown">
              <a
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    class="dropdown-item rounded-1"
                    href="javascript:void(0);"
                    @click.prevent="exportCsv"
                    v-can="'Reports.Export'"
                  >
                    <i class="ti ti-file-type-xls me-1"></i>Export as CSV
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item rounded-1"
                    href="javascript:void(0);"
                    @click.prevent="exportPdf"
                    v-can="'Reports.Export'"
                  >
                    <i class="ti ti-file-type-pdf me-1"></i>Export as PDF
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="head-icons ms-2">
            <a id="collapse-header" @click="toggleHeader">
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>

      <!-- Filters + KPIs -->
      <div class="row mb-3 dq-stat-grid">
        <div class="col-xl-8">
          <div class="card">
            <div class="card-body">
              <div class="row g-2">
                <div class="col-md-4">
                  <label class="form-label">From</label>
                  <input
                    v-model="filters.from"
                    type="date"
                    class="form-control"
                  />
                </div>
                <div class="col-md-4">
                  <label class="form-label">To</label>
                  <input
                    v-model="filters.to"
                    type="date"
                    class="form-control"
                  />
                </div>
                <div class="col-md-4">
                  <label class="form-label">Module</label>
                  <select v-model="filters.model" class="form-select">
                    <option value="">All</option>
                    <option v-for="m in modelOptions" :key="m" :value="m">
                      {{ m }}
                    </option>
                  </select>
                </div>
                <div class="col-md-4">
                  <label class="form-label">Action</label>
                  <select v-model="filters.action" class="form-select">
                    <option value="">All</option>
                    <option value="created">Created</option>
                    <option value="updated">Updated</option>
                    <option value="deleted">Deleted</option>
                    <option value="restored">Restored</option>
                  </select>
                </div>
                <div class="col-md-4">
                  <label class="form-label">Actor Type</label>
                  <select v-model="filters.actor_type" class="form-select">
                    <option value="">All</option>
                    <option value="superadmin">SuperAdmin</option>
                    <option value="tenant_admin">Tenant Admin</option>
                    <option value="user">User</option>
                    <option value="system">System</option>
                  </select>
                </div>
                <div class="col-md-4">
                  <label class="form-label">Search</label>
                  <input
                    v-model="filters.search"
                    type="text"
                    class="form-control"
                    placeholder="Search description/model..."
                  />
                </div>
                <div class="col-md-4 d-flex align-items-end">
                  <button class="btn btn-primary w-100" @click="fetch">
                    <i class="ti ti-search me-1"></i>Filter
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- KPI cards -->
        <div class="col-xl-4 d-flex">
          <div class="row flex-fill">
            <div class="col-sm-6 col-xl-12 d-flex" v-if="summary">
              <div class="card flex-fill dq-stat-card">
                <div class="card-body">
                  <h6 class="mb-1">Total Logs</h6>
                  <h4>{{ summary.total_logs || 0 }}</h4>
                  <p class="fs-12 text-muted mb-0">
                    From {{ summary.from }} to {{ summary.to }}
                  </p>
                </div>
              </div>
            </div>
            <!-- you can add more small cards for created / updated counts if you want -->
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="card">
        <div
          class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
        >
          <h5>Audit Trail</h5>
        </div>
        <div class="card-body p-0">
          <div class="custom-datatable-filter table-responsive">
            <AuditTrailReportTable
              :rows="store.rows"
              :loading="store.loading"
              :total="store.total"
              :page-size="store.pageSize"
              :current="store.current"
              @change="onTableChange"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>
</template>

<style scoped>
@media (max-width: 767.98px) {
  .dq-page-actions {
    align-items: stretch !important;
  }

  .dq-page-actions > * {
    width: 100%;
    margin-right: 0 !important;
  }

  .dq-page-actions .dropdown,
  .dq-page-actions .dropdown-toggle {
    width: 100%;
  }

  .dq-stat-card .card-body {
    padding: 1rem;
  }

  .card-body .row.g-2 > div[class*="col-"] {
    width: 100%;
  }

  .custom-datatable-filter.table-responsive {
    margin-left: -1rem;
    margin-right: -1rem;
    padding-left: 1rem;
    padding-right: 1rem;
    width: calc(100% + 2rem);
  }
}
</style>

<script setup>
import { reactive, onMounted, computed } from "vue";
import { useAuditTrailStore } from "@/stores/auditTrailStore";
import AuditTrailReportTable from "./audit-trail-report-table.vue";

const title = "Audit Trail";
const text = "Administration";
const text1 = "Audit Trail Report";

const store = useAuditTrailStore();

const filters = reactive({
  from: "",
  to: "",
  model: "",
  user_id: "",
  action: "",
  actor_type: "",
  search: "",
  page: 1,
  per_page: 25,
});

const summary = computed(() => store.summary || {});

const modelOptions = [
  "Employee",
  "EmployeeSalary",
  "PayrollConfig",
  "Leave",
  "User",
]; // extend as needed

function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

async function fetch() {
  await store.fetchAuditTrail({
    ...filters,
    page: filters.page,
    per_page: filters.per_page,
  });
}

function onTableChange(pagination) {
  filters.page = pagination.current;
  filters.per_page = pagination.pageSize;
  fetch();
}

function exportCsv() {
  store.exportAuditTrail("csv", { ...filters });
}

function exportPdf() {
  store.exportAuditTrail("pdf", { ...filters });
}

onMounted(() => {
  // default to last 7 days
  const today = new Date();
  const sevenDaysAgo = new Date();
  sevenDaysAgo.setDate(today.getDate() - 7);

  filters.to = today.toISOString().slice(0, 10);
  filters.from = sevenDaysAgo.toISOString().slice(0, 10);

  fetch();
});
</script>


